import {
    COMMON_NOTIFICATION,
    GET_BALANCE,
    GET_TARIFF,
    SUBSCRIPTION_INFO,
    CHECK_SUBSCRIPTION,
    GET_OPTIONS,
    GET_COUNTRIES
  } from '../constants';
  
  const initialState = { 
    common_notification:{
      message: '',
      isSuccess: 1
    },
    getBalanceData: {},
    subscriptionInfo: {},
    getTariffPalnData: [],
    checkSubscriptionDetails: {},
    customerOptionData: {},
    countries:[],
  }
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
  
      case COMMON_NOTIFICATION:
      return { ...state, 
        common_notification: (payload.message) ? payload : initialState.common_notification
      }

      case GET_TARIFF: {
        return {
          ...state,
          getTariffPalnData: payload,
        };
      }

      case GET_BALANCE: {
        return {
          ...state,
          getBalanceData: payload,
        };
      }

      case SUBSCRIPTION_INFO:
      return {
        ...state,
        subscriptionInfo: payload,
      };

      case CHECK_SUBSCRIPTION: {
        return {
          ...state,
          checkSubscriptionDetails: payload,
        };
      }

      case GET_OPTIONS: {
        return {
          ...state,
          customerOptionData: payload,
        };
      }

      case GET_COUNTRIES: {
        return {
          ...state,
          countries: payload,
        };
      }
    
      default:
        return state;
    }
  }
  
  export default reducer;